<template>
  <div
    class="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 px-16 shadow-[0_-4px_16px_rgba(0,0,0,0.04)] z-50"
    style="padding-top: 14px; padding-bottom: env(safe-area-inset-bottom); min-height: 80px;"
  >
    <div class="flex justify-between items-start">
      <router-link
        to="/timeline"
        class="flex flex-col items-center gap-1 transition-all"
        :class="isActive('/timeline') ? 'text-accent scale-105' : 'text-gray-400'"
      >
        <span class="text-3xl">👶</span>
        <span class="text-[10px] font-medium">時程</span>
      </router-link>

      <router-link
        to="/settings"
        class="flex flex-col items-center gap-1 transition-all relative"
        :class="isActive('/settings') ? 'text-accent scale-105' : 'text-gray-400'"
      >
        <span class="text-3xl relative">
          ⚙️
          <span
            v-if="hasPendingRequests"
            class="absolute top-0 right-0 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-white"
          />
        </span>
        <span class="text-[10px] font-medium">設定</span>
      </router-link>
    </div>
  </div>
</template>



<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '../stores/useAuthStore';

const route = useRoute();
const authStore = useAuthStore();
const isActive = (path: string) => route.path === path;
const hasPendingRequests = computed(() =>
  authStore.familyCode != null && Object.keys(authStore.pendingMembers).length > 0
);
</script>
